export const mapLevelSelector = (state) => state.map.mapLevel;
export const mapBoundsSelector = (state) => state.map.mapBounds;
export const isMapAdjustingSelector = (state) => state.map.isMapAdjusting;
export const showMapParcelDataMarkersSelector = (state) =>
  state.map.showMapParcelDataMarkers;
